/** Compact segmented "group by" switch, ERP-themed. */
export function SegGroup({
  value,
  onChange,
  options,
}: {
  value: string;
  onChange: (v: string) => void;
  options: { value: string; label: string }[];
}) {
  return (
    <div className="mb-3 inline-flex flex-wrap gap-1 rounded-lg border border-[var(--border-color)] bg-[var(--bg-secondary)] p-1">
      {options.map((o) => {
        const active = o.value === value;
        return (
          <button
            key={o.value}
            type="button"
            onClick={() => onChange(o.value)}
            className={
              'rounded-md px-3 py-1.5 text-xs font-bold transition ' +
              (active
                ? 'bg-accent text-white shadow-sm'
                : 'text-[var(--text-muted)] hover:bg-[var(--bg-soft)] hover:text-[var(--text-primary)]')
            }
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
}
